/**
 * TK-32 mục B.4 — TUỲ CHỌN THÔNG BÁO của trình duyệt này (cột "Cách thông báo" ở `/van-de`).
 * MỘT chỗ đọc/ghi: trang Vấn đề ghi, `PopupCanhBao` đọc. Lưu localStorage, mọi lần đọc/ghi bọc try/catch
 * (cửa sổ riêng tư ném) — hỏng thì dùng mặc định, không làm sập trang.
 *
 * ⛔ Chỉ có MỘT tuỳ chọn đổi hành vi: `popupMat` (popup cả Mất kết nối, mặc định TẮT). Popup Khẩn luôn bật —
 *   luật gom 5 s / chặn bão của `lib/popup.ts` giữ nguyên, không cho tắt tiếng mức 1 từ một ô đánh dấu.
 */
export const KHOA_THONG_BAO = 'sdkd.thongBao';
export interface TuyChonThongBao { popupMat: boolean }
export const THONG_BAO_MAC_DINH: TuyChonThongBao = { popupMat: false };

export function docThongBao(): TuyChonThongBao {
  try {
    const v = JSON.parse(localStorage.getItem(KHOA_THONG_BAO) ?? '{}');
    return { popupMat: v?.popupMat === true };
  } catch {
    return THONG_BAO_MAC_DINH;
  }
}

export function ghiThongBao(t: TuyChonThongBao): void {
  try { localStorage.setItem(KHOA_THONG_BAO, JSON.stringify(t)); } catch { /* không lưu được — giữ trong phiên */ }
}
